export const getServiceUrl = () => {
  const { protocol, hostname } = window.location;

  if (hostname === "localhost") {
    return `${protocol}//${hostname}:8000`;
  }

  return `${protocol}//${hostname}`;
};

export const SERVICE_URL = getServiceUrl();

export const IS_PRODUCTION = SERVICE_URL === "https://atlas.bb-int.net" || SERVICE_URL === "https://bricks.bb-int.net";
